var map = {
	"./calendar-outline.png": "./src/assets/icon/calendar-outline.png",
	"./clipboard-outline.png": "./src/assets/icon/clipboard-outline.png",
	"./cloud-download-outline.png": "./src/assets/icon/cloud-download-outline.png",
	"./email-outline.png": "./src/assets/icon/email-outline.png",
	"./eye-outline.png": "./src/assets/icon/eye-outline.png",
	"./facebook-outline.png": "./src/assets/icon/facebook-outline.png",
	"./file-text-outline.png": "./src/assets/icon/file-text-outline.png",
	"./folder-outline.png": "./src/assets/icon/folder-outline.png",
	"./image-outline.png": "./src/assets/icon/image-outline.png",
	"./inbox-outline.png": "./src/assets/icon/inbox-outline.png",
	"./link-2-outline.png": "./src/assets/icon/link-2-outline.png",
	"./message-square-outline.png": "./src/assets/icon/message-square-outline.png",
	"./options-2-outline.png": "./src/assets/icon/options-2-outline.png",
	"./people-outline.png": "./src/assets/icon/people-outline.png",
	"./person-add-outline.png": "./src/assets/icon/person-add-outline.png",
	"./person-outline.png": "./src/assets/icon/person-outline.png",
	"./pie-chart-outline.png": "./src/assets/icon/pie-chart-outline.png",
	"./printer-outline.png": "./src/assets/icon/printer-outline.png",
	"./search-outline.png": "./src/assets/icon/search-outline.png",
	"./settings-outline.png": "./src/assets/icon/settings-outline.png",
	"./share-outline.png": "./src/assets/icon/share-outline.png",
	"./toggle-right-outline.png": "./src/assets/icon/toggle-right-outline.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/icon sync recursive ^\\.\\/.*\\.png$";